var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("secondary-navigation-bar", {
        attrs: { navigation: _vm.navigation, "data-qa-prefix": "profile" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gfu-profile-view" },
        [
          _vm.isPublic
            ? _c("router-view", { attrs: { name: "profile" } })
            : _c(
                "div",
                {
                  staticClass: "gfu-layout__main gfu-layout__main--extranarrow",
                },
                [
                  _c(
                    "box",
                    { staticClass: "_mt-6" },
                    [
                      _vm.isViewingOwnProfile
                        ? _c(
                            "empty-state",
                            {
                              attrs: {
                                title:
                                  _vm.Resources.Profile
                                    .EmptyStateProfileStatusPrivateTitle,
                                "data-qa": "user-profile:PrivateState",
                              },
                            },
                            [
                              _c("div", { staticClass: "_mt-3" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.Resources.Profile
                                        .EmptyStateProfileStatusPrivateOwnProfileParagraph
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticClass: "_mt-3",
                                  attrs: {
                                    tag: "a",
                                    href: _vm.accountSettingsUrl,
                                    theme: "accent",
                                    "format-key": "0",
                                    "data-qa":
                                      "user-profile:ManagePrivacyButton",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.Resources.Profile
                                        .EmptyStateProfilePrivateStatusOwnProfileAction
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "empty-state",
                            {
                              attrs: {
                                title:
                                  _vm.Resources.Profile
                                    .EmptyStateProfileStatusPrivateTitle,
                              },
                            },
                            [
                              _c("div", { staticClass: "_mt-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.Resources.Profile
                                      .EmptyStateProfileStatusPrivateParagraph
                                  )
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }